module.exports = __webpack_public_path__ + "static/media/settings.2856b260.svg";